import React from 'react'
import { appStore } from '~/stores'
import { observer } from '~/ui/component'
import { Center, FlipNavigator, Spinner } from '~/ui/components'
import { AuthLayout } from '~/ui/layouts'
import AuthResetScreen from '../auth/auth-reset/AuthResetScreen'
import ForgotPinScreen from '../auth/forgot-pin/ForgotPinScreen'
import LoginScreen from '../auth/login/LoginScreen'

export interface Props {

}

const AuthNavigator = observer('AuthNavigator', (props: Props) => {

  const showEmailAndPinFields = appStore.app?.auth.emailAndPincode !== false
  const singleOAuthProvider   = appStore.app != null && appStore.app.auth.oAuthProviders.length === 1 ? appStore.app.auth.oAuthProviders[0] : null

  React.useEffect(() => {
    if (showEmailAndPinFields || singleOAuthProvider == null) { return }
    document.location.pathname = `/oauth/${singleOAuthProvider.name}/redirect`
  }, [showEmailAndPinFields, singleOAuthProvider])

  //------
  // Rendering

  function render() {
    if (!showEmailAndPinFields && singleOAuthProvider != null) {
      return (
        <Center flex>
          <Spinner size={16} dim/>
        </Center>
      )
    }
    return (
      <AuthLayout>
        <FlipNavigator>
          <FlipNavigator.Route
            side='front'
            component={LoginScreen}
            path='/login'
            exact
          />
          <FlipNavigator.Route
            side='back'
            component={ForgotPinScreen}
            path='/auth/forgot-pin'
            exact
          />
          <FlipNavigator.Route
            side='back'
            component={AuthResetScreen}
            path='/auth/reset'
            exact
          />
        </FlipNavigator>
      </AuthLayout>
    )
  }

  return render()

})

export default AuthNavigator